import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { useAuth, BACKEND_URL } from "../context/AuthContext";
import Header from "../components/Header";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("No verification token found.");
      return;
    }
    fetch(`${BACKEND_URL}/api/auth/verify-email?token=${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (res.ok) {
          setStatus("success");
          setMessage(data.message || "Email verified!");
          await checkAuth();
        } else {
          setStatus("error");
          setMessage(data.detail || "Verification failed.");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("Something went wrong. Please try again.");
      });
  }, [searchParams, checkAuth]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />
      <div className="flex items-center justify-center min-h-[80vh] px-6">
        <div className="text-center max-w-md">
          {status === "verifying" && (
            <>
              <Loader2 className="w-12 h-12 text-purple-400 animate-spin mx-auto mb-4" />
              <h1 className="text-2xl font-bold mb-2" data-testid="verify-heading">Verifying your email...</h1>
              <p className="text-white/50">Just a moment.</p>
            </>
          )}
          {status === "success" && (
            <>
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-green-400" />
              </div>
              <h1 className="text-2xl font-bold mb-2" data-testid="verify-success">Email Verified!</h1>
              <p className="text-white/50 mb-6">{message}</p>
              <button
                onClick={() => navigate("/dashboard")}
                className="bg-purple-500 hover:bg-purple-600 text-white px-8 py-3 rounded-xl font-semibold transition"
                data-testid="verify-go-dashboard"
              >
                Go to Dashboard
              </button>
            </>
          )}
          {status === "error" && (
            <>
              <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle className="w-8 h-8 text-red-400" />
              </div>
              <h1 className="text-2xl font-bold mb-2" data-testid="verify-error">Verification Failed</h1>
              <p className="text-white/50 mb-6">{message}</p>
              <button
                onClick={() => navigate("/dashboard")}
                className="bg-purple-500 hover:bg-purple-600 text-white px-8 py-3 rounded-xl font-semibold transition"
                data-testid="verify-go-dashboard-error"
              >
                Go to Dashboard
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
